import { useEffect } from 'react';
import { useQueryClient, QueryKey } from 'react-query';
import { CallIntelTypes } from '@frontend/api-call-intel';
import { useCallTakeawayPanelStore } from './use-call-takeaway-panel-store';

export const useSyncSelectedCallToQuery = (
  source: CallIntelTypes.PanelSource,
  queryKey: QueryKey,
  makeNewData: (selectedCall: CallIntelTypes.Call) => unknown
) => {
  const qc = useQueryClient();

  useEffect(() => {
    const unsub = useCallTakeawayPanelStore.subscribe(
      (s) => s.contexts[source]?.selectedCall,
      (newCall) => {
        if (!newCall) return;
        qc.setQueryData(queryKey, () => makeNewData(newCall));
      }
    );
    return unsub;
  }, [source, queryKey, qc, makeNewData]);
};
